const playList = {
  state: {
    playList: [
      // {
      //   book_title: '战马',
      //   title:'章节1',
      //   media: "http://media2.youshu.cc/readwith/media/291869/5ac067e85437a.mp3",
      //   top_img: 'http://img.youshu.cc/readoo/20180321/5ab1ffb3cee18.jpg',
      //   media_size: '15269032',
      //   media_time: '15:54',
      //   read_count: '222',
      //   id: '21170',
      //   book_id: '291869'
      // },
      // {
      //   book_title: '战马',
      //   title:'章节2',
      //   media: "http://media2.youshu.cc/readwith/media/291869/5ac06a9c9f791.mp3",
      //   top_img: 'http://img.youshu.cc/readoo/20180321/5ab1ffb3cee18.jpg',
      //   media_size: '6290440',
      //   media_time: "06:33",
      //   read_count: '333',
      //   id: '21167',
      //   book_id: '291869'
      // }
    ],
    musicInfo: {
      book_title: '',
      title:'',
      read_count: '',
      media: "",
      top_img: '',
      media_size: '',
      media_time: '',
      id: '',
      book_id: '',
      playingIndex: '',
      playingMedia: ""
    },
    isPlaying: false,
    currentTime: 0
  },
  mutations: {
    SET_MUSIC_INFO: (state, musicInfo) => {
      state.musicInfo = musicInfo
    },
    SET_PLAY_LIST: (state, playList) => {
      state.playList = playList
    },
    SET_IS_PLAYING: (state, a) => {
      state.isPlaying = a
    },
    SET_CURRENT_TIME: (state, a) => {
      state.currentTime = a
    }
  },
  actions: {
    setMusicInfo({ commit }, info) {
      commit('SET_MUSIC_INFO', info)
    },
    setPlayList({ commit }, list) {
      commit('SET_PLAY_LIST', list)
    },
    setIsPlaying({ commit }, a) {
      commit('SET_IS_PLAYING', a)
    },
    setCurrentTime({ commit }, a) {
      commit('SET_CURRENT_TIME', a)
    }
  }
}

export default playList
